"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var viewType = exports.viewType = {
    layout: "__layout__",
    page: "__page__"
};


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_web-router@0.2.0-alpha.1@@bone/web-router/lib/constants.js
// module id = 386
// module chunks = 4